import React from 'react';

import { imageResizer } from 'utils/image';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';
import NewImage from 'components/layout/NewImage';
import Description from 'components/modules/public/layout/sections/Description';
import { Layouts } from 'components/modules/public/layout/sections/Description/types';

import { Props } from './index';
import StyledComponent from './styles';

const TwoColsSimpleCmsSection: React.FC<Props> = ({ section }): React.ReactElement => {
    const image: string = section?.image?.imageUrl;
    const title: string = section?.title;
    const description: string  = section?.description;

    return (
        <StyledComponent className='public-cms-sections-two-cols-simple-cms-section'>
            <LayoutContainer size={Sizes.Large}>
                <div className='box-content'>
                    <Description
                        headline={title ? `<h2>${title}</h2>` : null}
                        description={description}
                        layout={Layouts.Left}
                    />
                </div>
                {image && (
                    <NewImage
                        className="box-image"
                        src={imageResizer(image, { width: 731, height: 542 })}
                        srcSet={imageResizer(image, { width: 731, height: 542 }, true)}
                        alt={''}
                    />
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default TwoColsSimpleCmsSection;
